import ComponentHeader from '../main/ComponentHeader';
import GruntComponents from '../components';
import { loggedOper as lp } from '../../util/grunt';
import {Box, InputGroup, InputLeftElement, Input, Spacer, Stack, Menu,MenuButton, Button,
   MenuList, MenuItem, Drawer, DrawerOverlay, DrawerContent, DrawerHeader, DrawerBody, useToast,IconButton,Tooltip,
   Modal,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,SkeletonCircle,SkeletonText,
   ModalCloseButton} from '@chakra-ui/react';
import { SearchIcon, ChevronDownIcon } from '@chakra-ui/icons';
import { useState, useEffect } from 'react';
import Dolazak from './Dolazak';
import { addDolazak, editDolazak as editUnesenDolazak, deleteDolazak, getDolasci,getDolasciFilter, editDolazakScan } from '../../util/apiMigracija';
import DolasciTable from './DolasciTable';
import {MdFilterAltOff, MdFilterAlt,MdInfo} from 'react-icons/md';
import {RiFileExcel2Fill} from "react-icons/ri"
import { userReadOnly } from '../../util/grunt';
import DolasciFilter from './DolasciFilter';
import DolazakStatistika from './DolazakStatistika';
import DolazakFilterInfo from './DolazakFilterInfo';

export default function Dolasci({onClosePress, size='xs'}) {
  
  const [state,setState]=useState({newDolazak:"",editDolazakMigracijaId:0,editMigracijaTipSifra:"",viewDolazakMigracijaId:0,viewMigracijaTipSifra:"",toggleShowData:false})
  const [statistikadolaska,setStatistikaDolaska]=useState(0);
  const [dolasci,setDolasci]=useState([]);
  const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",dolasciprikaz:[],rowsperpage:20,currpage:1});
  const [filter,setFilter]=useState({filterStatus:"off",showFilter:false,filterData:{},ispisType:'app'})
  const [showFilters,setShowFilters]=useState(false);
  const [dataIsFetching,setDataIsFetching]=useState(false);
  const [canSave,setCanSave]=useState(true)
  const toast=useToast();
  const userCanEdit=lp.uloga==="r"?false:true;
  const fetchDolasci=async ()=>{
    let res;
    setDataIsFetching(true);
    try {
          if (Object.keys(filter.filterData).length===0) {
            res=await getDolasci({responsedatatype:filter.ispisType});
          } else {
            let _param=filter.filterData;
            _param.responsedatatype=filter.ispisType;
            res=await getDolasciFilter(_param);
          }
        
        if (res.status===200) {
          if (filter.ispisType==="app") {
            setDolasci(res.res);
            setPrikaz({...prikaz,dolasciprikaz:res.res}); 
          } else if (filter.ispisType==='xlsx') {
            const blob = new Blob([res.res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                                        
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = url;
            a.download = "Dolasci.xlsx";
            a.click();
            window.URL.revokeObjectURL(url);
          }
            
        } else {
            throw new Error(res.message);
        }
    } catch (error) {
        toast({
            title:"Greška kod dohvata podataka.",
            status:"error",
            description:error.message,
            isClosable:true,
            duration:2000,
            position:"top-right",
        });
    } finally {
      setDataIsFetching(false);
      if (filter.ispisType!=='app') {
        setFilter({...filter,ispisType:'app'});
      }
    }
}

useEffect(() => {
  fetchDolasci();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [filter.filterData,state.toggleShowData])




  const getNewDolazakControl=()=>{
    if (state.newDolazak!=="") {
      let _naslov="Kupnja";
      switch (state.newDolazak) {
        case "DUVOZ":
          _naslov="Uvoz";
          break;
        case "DTELJ":
        _naslov="Teljenje";
          break;
        default:
          _naslov="Kupnja";
      }
        return (
            <Drawer placement='right' size={'lg'} isOpen={true}>
            <DrawerOverlay/>
            <DrawerContent roundedTopLeft={'md'}>
                <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                    {_naslov}
                </DrawerHeader>
                <DrawerBody>
                        <Dolazak _canSave={canSave} dolazak_tip_sifra={state.newDolazak} onClose={closeDolazakControl} onSave={saveDolazak} readonly={!userCanEdit}/>
                </DrawerBody>
            </DrawerContent>
            </Drawer>
        )
    }
}

const getEditDolazakControl=()=>{
  if (state.editDolazakMigracijaId!==0) {
    let _naslov="Kupnja";
      switch (state.editMigracijaTipSifra) {
        case "DUVOZ":
          _naslov="Uvoz";
          break;
        case "DTELJ":
        _naslov="Teljenje";
          break;
        default:
          _naslov="Kupnja";
      }
    return (
      <Drawer placement='right' size={'lg'} isOpen={true}>
      <DrawerOverlay/>
      <DrawerContent roundedTopLeft={'md'}>
          <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
              {_naslov}
          </DrawerHeader>
          <DrawerBody>
                  <Dolazak _canSave={canSave} dolazak_tip_sifra={state.editMigracijaTipSifra} onClose={closeDolazakControl} onSave={saveDolazak} onDelete={delDolazak} readonly={!userCanEdit} newDolazak={false} dolazakMigracijaId={state.editDolazakMigracijaId}/>
          </DrawerBody>
      </DrawerContent>
      </Drawer>
  )
  }
}
const getViewDolazakControl=()=>{
  if (state.viewDolazakMigracijaId!==0) {
    let _naslov="Kupnja";
      switch (state.editMigracijaTipSifra) {
        case "DUVOZ":
          _naslov="Uvoz";
          break;
        case "DTELJ":
        _naslov="Teljenje";
          break;
        default:
          _naslov="Kupnja";
      }
    return (
      <Drawer placement='right' size={'lg'} isOpen={true}>
      <DrawerOverlay/>
      <DrawerContent roundedTopLeft={'md'}>
          <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
              {_naslov}
          </DrawerHeader>
          <DrawerBody>
                  <Dolazak dolazak_tip_sifra={state.editMigracijaTipSifra} onClose={closeDolazakControl} onSave={saveDolazak} onDelete={delDolazak} readonly={true} newDolazak={false} dolazakMigracijaId={state.viewDolazakMigracijaId}/>
          </DrawerBody>
      </DrawerContent>
      </Drawer>
  )
  }
}

const onModalClose=()=>{
  setStatistikaDolaska(0);
}

const getStatistikaDolaskaControl=()=>{
  if (statistikadolaska!==0) {
    return (
      <Modal isOpen={true} onClose={onModalClose} size={size} closeOnOverlayClick={false}>
        <ModalContent shadow={'dark-lg'}>
          <ModalHeader bg={'gray.100'} color={'grunt2.700'} roundedTop={'md'}>Info</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <DolazakStatistika migracijaid={statistikadolaska} />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme='grunt2' variant={'outline'} mr={3} onClick={onModalClose} size={size}>
              Zatvori
            </Button>
            
          </ModalFooter>
        </ModalContent>
      </Modal>
      
    )
  }
}

const onCloseFilter=()=>{

  setFilter({...filter,showFilter:false});
}

const onSetFilterDolazaka=(f)=>{
  setFilter({...filter,filterData:f,filterStatus:"on",showFilter:false});
}
const getFilterControl=()=>{
  if (filter.showFilter) {
    return (
      <Drawer placement='right' size={'lg'} isOpen={true}>
      <DrawerOverlay/>
      <DrawerContent roundedTopLeft={'md'}>
          <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
              Napredno filtriranje dolazaka
          </DrawerHeader>
          <DrawerBody p='0.5rem'>
                  <DolasciFilter onSetFilter={onSetFilterDolazaka} onClose={onCloseFilter} />
          </DrawerBody>
      </DrawerContent>
      </Drawer>
  )
  }
}

const closeDolazakControl=()=>{
  setState({...state,newDolazak:"",editDolazakMigracijaId:0,editMigracijaTipSifra:"",viewDolazakMigracijaId:0,viewMigracijaTipSifra:""});
}

const saveDolazak= async ({dokumenttipid,migracijatipsifra,knjigaid,datum,posjednikid,uktezina,ijr,dokumentbroj,goveda=[],govscansid=[],jibg=""})=>{
  try {
    setCanSave(false)
    let res;
    if (state.editDolazakMigracijaId===0) {
        //add new
         res=await addDolazak({dokumenttipid,migracijatipsifra,knjigaid,datum,posjednikid,uktezina,ijr,dokumentbroj,goveda,govscansid,jibg:jibg});
    } else {
        //edit
        if (govscansid.length>0) {
          res=await editDolazakScan({dmigracijaid:state.editDolazakMigracijaId,dokumenttipid:dokumenttipid,migracijatipsifra:migracijatipsifra,knjigaid:knjigaid,
            datum:datum,posjednikid:posjednikid,uktezina:uktezina,ijr:ijr,dokumentbroj:dokumentbroj,govscansid:govscansid});
        } else {
          res=await editUnesenDolazak({dmigracijaid:state.editDolazakMigracijaId,dokumenttipid,migracijatipsifra,knjigaid,datum,posjednikid,uktezina,ijr,dokumentbroj,goveda,jibg:jibg});
        }
         
         

    }
      
    
    if (res.status===200) {

        //setPrikaz({...prikaz,showKlaonica:false,selectedKlaonica:{},fetchklaonice:prikaz.fetchklaonice+1})
        setState({...state,newDolazak:"",editDolazakMigracijaId:0,editMigracijaTipSifra:"",viewDolazakMigracijaId:0,viewMigracijaTipSifra:"",toggleShowData:!state.toggleShowData});
        toast({
            title:"Podatak spremljen",
            status:"success",
            isClosable:true,
            duration:1500,
            position:"top-right",
        });
    } else {
       
            throw new Error(res.message);
       
    }
} catch (ex) {
toast({
    title:"Greška kod unosa",
    status:"error",
    description:ex.message,
    isClosable:true,
    duration:2000,
    position:"top-right",
});
} finally {
  setCanSave(true);
}
}

const delDolazak= async (migracijaid)=>{
  try {
    let res;
    if (migracijaid===0) {
        //add new
         alert("Pokušaj brisanja dolazne migracije a nije proslijeđen migracijaid!!!1")
    } else {
        //edit
         res=await deleteDolazak({migracijaid:migracijaid});
         

    }
      
    
    if (res.status===200) {

        //setPrikaz({...prikaz,showKlaonica:false,selectedKlaonica:{},fetchklaonice:prikaz.fetchklaonice+1})
        setState({...state,newDolazak:"",editDolazakMigracijaId:0,editMigracijaTipSifra:"",viewDolazakMigracijaId:0,viewMigracijaTipSifra:"",toggleShowData:!state.toggleShowData});
        toast({
            title:"Dolazna migracija obrisana",
            status:"success",
            isClosable:true,
            duration:1500,
            position:"top-right",
        });
    } else {
       
            throw new Error(res.message);
       
    }
} catch (ex) {
toast({
    title:"Greška kod brisanja dolazne migracije",
    status:"error",
    description:ex.message,
    isClosable:true,
    duration:2000,
    position:"top-right",
});
}
}

const btnNew=()=>{
  if (userCanEdit) {
      return (
         <Menu size={'sm'}>
              <MenuButton as={Button} rightIcon={<ChevronDownIcon />} variant={'outline'} colorScheme={'grunt2'} size={size}>
                  Dolazak
              </MenuButton>
              <MenuList fontSize={size}>
                  <MenuItem onClick={(e)=>setState({...state,newDolazak:"DKUP"})}>Kupnja</MenuItem>
                  <MenuItem onClick={(e)=>setState({...state,newDolazak:"DUVOZ"})}>Uvoz</MenuItem>
                  <MenuItem onClick={(e)=>setState({...state,newDolazak:"DTELJ"})}>Teljenje</MenuItem>
              </MenuList>
          </Menu>
          )
  } else {
      return (
          <></>
          )
  }
}

const editDolazak=(migracijaid,migracijatipsifra)=>{
  setState({...state,newDolazak:"",editDolazakMigracijaId:migracijaid,editMigracijaTipSifra:migracijatipsifra});
  //setState({editDolazakMigracijaId:migracijaid,editMigracijaTipSifra:migracijatipsifra});
}

const viewDolazak=(migracijaid,migracijatipsifra)=>{
  setState({...state,viewDolazakMigracijaId:migracijaid,viewMigracijaTipSifra:migracijatipsifra});
}

const statistkaDolaska=(migracijaid)=>{
  setStatistikaDolaska(migracijaid);
}


const getDolasciTable=()=>{
  if (dataIsFetching && filter.ispisType==="app") {
    return (
      <Box>
        <SkeletonCircle size='10' />
        <SkeletonText mt='4' noOfLines={30} spacing='3' skeletonHeight='2' />
      </Box>
    ) 
  } else {
    return (<DolasciTable readonly={userReadOnly()} dolasci={prikaz.dolasciprikaz} onEditDolazak={editDolazak} onViewDolazak={viewDolazak} onStat={statistkaDolaska} />) 
  }
}
const setFilterState=(filtstatus)=>{
  if (filtstatus==="off") {
    setFilter({...filter,filterStatus:filtstatus,filterData:{}});  
  }
  else {
    setFilter({...filter,filterStatus:filtstatus});  
  }
  
}

const onshowFilter=()=>{
  setFilter({...filter,showFilter:true});
}

const FilterData=(filter)=>{
  const _val=filter.target.value.toLowerCase();
  let _o=dolasci.filter((dol)=>{
      return (dol.knjiga.toLowerCase().includes(_val) || dol.migracija_tip.toLowerCase().includes(_val) || dol.odlposjednik.toLowerCase().includes(_val) || dol.dokument_broj.toLowerCase().includes(_val) || dol.odldrzava.toLowerCase().includes(_val) || dol.odldrzavacode.toLowerCase().includes(_val));
  });
  setPrikaz({...prikaz,dolasciprikaz:_o,currpage:1}); 
}

const displayFilters=()=>{
  if (showFilters) {
    const _dat={datod:'1900-01-01',datdo:'1900-01-01'}
    if (filter.filterData.datumod!==undefined && filter.filterData.datumdo!==undefined) {
      _dat.datod=filter.filterData.datumod;
      _dat.datdo=filter.filterData.datumdo;
    }
    return (
      <Modal isOpen={true} closeOnOverlayClick={false} size={'md'} colorScheme="blue" onClose={()=>{setShowFilters(false)}}>
        <ModalContent shadow={'dark-lg'}>
          <ModalHeader bgColor={'gray.100'} color={'grunt2.600'} fontSize={'sm'}>
            Aktivni filteri
          </ModalHeader>
          <ModalCloseButton size={'sm'}/>
          <ModalBody>
              <DolazakFilterInfo _knjige={filter.filterData.knjige} _tipovidolazaka={filter.filterData.dolazaktipovi} _posjednici={filter.filterData.odlazniposjednici} _drzave={filter.filterData.drzave} _period={_dat} />
            
          </ModalBody>

          <ModalFooter>
            
            
          </ModalFooter>
        </ModalContent>
      </Modal>
      )  
  }
}
const getExcel=()=>{
  setFilter({...filter,ispisType:'xlsx'});
  setDataIsFetching(true);
  setState({...state,toggleShowData:!state.toggleShowData});
}

  return (
    // <Box   h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl='0.5rem' pr={'0.5rem'}>
    <Box   display={'flex'} flexDir={'column'} h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl='0.5rem' pr={'0.5rem'}>
        <ComponentHeader onClosePress={onClosePress} component={GruntComponents.Dolasci}/>
        <Box  display={'flex'} flexDirection={'row'} h={'2rem'} alignItems={'center'} mb={'0.5rem'}>
                  <Box mr={'0.5rem'}>
                    <InputGroup size={size} w='20rem'>
                        <InputLeftElement pointerEvents={'none'} children={<SearchIcon/>}/>
                        <Input focusBorderColor='grunt2.400' placeholder='Filter' maxLength={'20'} onChange={FilterData}/>
                    </InputGroup>
                    </Box>
                    <IconButton onClick={onshowFilter} key={'btnFilterOn'} variant={filter.filterStatus!=='off'?'solid':'outline'} colorScheme={'grunt2'} aria-label='Napredno filtriranje' icon={<MdFilterAlt/>} size={size}/>
                    <Tooltip label={'Aktivni filteri'}>
                      <IconButton ml={'0.5rem'} onClick={()=>{setShowFilters(true)}} key={'btnFilterOff'} variant={'outline'} colorScheme={'grunt2'} aria-label='Napredno filtriranje' icon={<MdInfo/>} size={size}/>
                    </Tooltip>
                    <Tooltip label={'Ukloni filtere'}>
                      <IconButton ml={'0.5rem'} onClick={(e)=>setFilterState("off",e)} key={'btnFilterOff'} variant={'outline'} colorScheme={'grunt2'} isDisabled={filter.filterStatus==='off'} aria-label='Napredno filtriranje' icon={<MdFilterAltOff/>} size={size}/>
                    </Tooltip>
                    <Tooltip label={'Izvezi u Excel'}>
                      <IconButton isLoading={filter.ispisType==="xlsx" && dataIsFetching} ml={'0.5rem'} onClick={getExcel} key={'btnExcel'} variant={'outline'} colorScheme={'grunt2'}  aria-label='Ispis' icon={<RiFileExcel2Fill/>} size={size}/>
                    </Tooltip>
                    <Spacer/>
                    <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}>
                    {btnNew()}    
                    </Stack>
                    
            
        </Box>
        <Box display={'flex'} flexDir={'column'} flex={1}>
          {getDolasciTable()}
          {getNewDolazakControl()}
          {getEditDolazakControl()}
          {getViewDolazakControl()}
          {getFilterControl()}
          {getStatistikaDolaskaControl()}
          {displayFilters()}
        </Box>
    </Box>
  )
}
